import { Config } from './SiteConfig';

export class SiteConfigFetcher {
  public static fetch(): Promise<Config> {
    return fetch('/config.json').then((r) => r.json());
  }
}
